import "./RoofingServices.module.css";
import Header from "@/reusable_sections/Header";
import RoofingHero from "./sections/RoofingHero";
import Roofing from "./sections/Roofing";
import Inspection from "./sections/Inspection";
import Footer from "@/reusable_sections/Footer";
export default function RoofingServicesPage() {
  return <div>
      <Header />
      <RoofingHero />
      <Roofing />
      <Inspection />
      <Footer />
    </div>;
}